import { reqGetTenants,reqGetTenantProfiles } from "@/api/api.js";

const state = {
  tenantsList: [],
  tenantsInfo: [],
  tenantProfilesList: [],
  tenantProfilesInfo: [],
};
const mutations = {
  GETTENANTSLIST(state, tenantsList) {
    state.tenantsList = tenantsList;
  },
  GETTENANTSINFO(state, tenantsInfo) {
    state.tenantsInfo = tenantsInfo;
  },
  GETTENANTPROFILESLIST(state, tenantProfilesList) {
    state.tenantProfilesList = tenantProfilesList;
  },
  GETTENANTPROFILESINFO(state, tenantProfilesInfo) {
    state.tenantProfilesInfo = tenantProfilesInfo;
  },
};
const actions = {
  async getTenantsList({ commit }, data) {
    let result = await reqGetTenants(data);
    if (result.status === 200) {
      commit("GETTENANTSLIST", result.data);
      commit("GETTENANTSINFO", result.data.data);
    }
  },
  async getTenantProfilesList({ commit }, data) {
    let result = await reqGetTenantProfiles(data);
    if (result.status === 200) {
      commit("GETTENANTPROFILESLIST", result.data);
      commit("GETTENANTPROFILESINFO", result.data.data);
    }
  },
};
const getters = {
  tenantsList(state) {
    return state.tenantsList || {};
  },
  tenantsInfo(state) {
    for (let i = 0; i < state.tenantsInfo.length; i++) {
      const date = new Date(state.tenantsInfo[i].createdTime);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var min = date.getMinutes();
      min = min < 10 ? "0" + min : min;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      state.tenantsInfo[i].createdTime =
        y + "-" + m + "-" + d + " " + h + ":" + min + ":" + s;
    }
    return state.tenantsInfo || {};
  },
  tenantProfilesList(state) {
    return state.tenantProfilesList || {};
  },
  tenantProfilesInfo(state) {
    for (let i = 0; i < state.tenantProfilesInfo.length; i++) {
      const date = new Date(state.tenantProfilesInfo[i].createdTime);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var min = date.getMinutes();
      min = min < 10 ? "0" + min : min;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      state.tenantProfilesInfo[i].createdTime =
        y + "-" + m + "-" + d + " " + h + ":" + min + ":" + s;
    }
    return state.tenantProfilesInfo || [];
  },

};

export default {
  state,
  mutations,
  actions,
  getters,
};
